import { WithLazy } from "@quintype/components";
import { get } from "lodash";
import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { ThreeColGrid } from "../../../arrow/index.js";
import { useDeviceType } from "../../customHooks/useDeviceType.js";
import { getCardType } from "../../utils/index.js";
import { AgendaSection } from "./Agenda/AgendaSection.js";
import { Header } from "./CustomNavHeader/Header.js";
import PoweredBy from "./CustomNavHeader/PoweredBy.js";
import { FaqSection } from "./Faq/FaqSection.js";
import KeyProfiles from "./KeyProfiles/index.js";
import { Note } from "./Note/index.js";
import Overview from "./Overview/index.js";
import { PartnerContainer } from "./Partners/PartnerContainer.js";
import Profiles from "./Profiles/index.js";
import SpeakersPanel from "./SpeakersPanel/index.js";
import "./styles.m.css";
import { WinnersSection } from "./Winners/WinnersSection.js";

export function CustomEventPage(props) {
  const { config } = props;
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const eventName = useSelector(() => get(qtState, ["data", "eventStory", "metadata", "story-attributes", "event_name", 0], {}));
  const { eventStory, rankingsData, collectionsData } = get(qtState, ["data"], {});
  const { "hero-image-s3-key": heroImageS3Key } = eventStory;

  const pageType = qtState.pageType;
  const eventStoryCards = get(eventStory, ["cards"], []);
  const eventNameclass = eventName === "startup-summit-2026" ? "startupevent" : "";


  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";

  const cdnImage = `https://${config?.["cdn-image"]}`;

  const slug = isDesktop
    ? get(eventStory, ["hero-image-s3-key"])
    : get(
        eventStory,
        ["alternative", "home", "default", "hero-image", "hero-image-s3-key"],
        get(eventStory, ["hero-image-s3-key"])
      );

  const heroImage = `${cdnImage}/${slug}`;

  const scrollInnerRef = useRef(null);
  const indexRef = useRef(0);
  const numberOfSponsore = 1;
  useEffect(() => {
    if (numberOfSponsore > 2) {
      const scrollInner = scrollInnerRef.current;
      const itemWidth = isDesktop ? 187 : (window.innerWidth - 56) / 2;
      const totalItems = 5;

      const scrollNext = () => {
        indexRef.current += 1;
        scrollInner.style.transition = "transform 0.5s ease-in-out";
        scrollInner.style.transform = `translateX(-${indexRef.current * itemWidth}px)`;

        if (indexRef.current === totalItems - 2) {
          setTimeout(() => {
            scrollInner.style.transition = "none";
            scrollInner.style.transform = "translateX(0px)";
            indexRef.current = 0;
          }, 600);
        }
      };

      const interval = setInterval(scrollNext, 2000);

      return () => clearInterval(interval);
    }
  }, [isDesktop]);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "dl_page_info",
      cms_author_name: "NA",
      byline: "NA",
      category: "custom-event-page",
      sub_category: "NA",
      content_id: "NA",
      template_name: "listing",
      publish_date: "NA",
      publish_time: "NA",
      login_status: "not-logged-in", // will be changed
      subscription_status: "not-subscribed", // will be changed
      ad_free: false, // will be changed
      login_wall_enabled: false,
      platform: window.innerWidth >= 768 ? "Desktop" : "Mobile",
    });
  }, []);

  return (
    <div
      styleName={`custom-event-page ${eventNameclass}`}
    >
      <Header />
      <div styleName="hero-image" style={{ paddingTop: isDesktop ? "64px" : "58px" }}>
        <WithLazy>
          {() => {
            return <img src={heroImage} alt="Hero Image" />;
          }}
        </WithLazy>
      </div>
      <div styleName="event-wrapper">
        <div styleName="content-wrapper">
          {eventStoryCards.map((card) => {
            const cardType = getCardType(card);
            switch (cardType) {
              case "Logo Carousel":
                return <PoweredBy card={card} cdnImage={cdnImage} />;
              case "Overview":
                return <Overview card={card} cdnImage={cdnImage} />;
              case "Speakers Panel":
                return <SpeakersPanel card={card} cdnImage={cdnImage} />;
              case "Key Profiles":
                return <KeyProfiles card={card} cdnImage={cdnImage} />;
              case "Fireside Profiles":
                return <KeyProfiles card={card} cdnImage={cdnImage} isFireSideProfile="true" />;
              case "Profiles":
                return <Profiles card={card} cdnImage={cdnImage} />;
              case "Agenda":
                return <AgendaSection card={card} />;
              case "Profile Rankings":
                const rankingDataCard = rankingsData.find((profile) => profile.cardId === card.id);
                return <WinnersSection card={rankingDataCard} cdnImage={cdnImage} />;
              case "Multiple Profiles":
                return <SpeakersPanel card={card} cdnImage={cdnImage} />;
              case "Logo Board":
                return <PartnerContainer card={card} cdnImage={cdnImage} />;
              case "FAQ":
                return <FaqSection card={card} />;
              case "Note":
                return <Note card={card} />;
              case "Collections":
                const collectionData = collectionsData.find((collection) => collection.cardId === card.id);
                const id = get(collectionData, ["metadata", "attributes", "menuname", "0"], "");
                return (
                  <ThreeColGrid
                    collection={collectionData.collection}
                    customCollectionName={collectionData.title}
                    config={{
                      theme: "#fff",
                      border: "top",
                      localizationConfig: {
                        hideReadTime: true,
                      },
                      showReadTime: false,
                      slotConfig: [],
                      disableAds: true,
                    }}
                    template="default"
                    id={`${id.toLowerCase()}`}
                    initialLoadCount={6}
                    isLoadMoreVisible={true}
                    page="custom-event-page"
                    showAuthorContent={false}
                    isLoading={false}
                  />
                );
              default:
                return null;
            }
          })}
        </div>
      </div>
    </div>
  );
}
